import { Spin } from 'antd'
import React from 'react'
import './loading.less'

const LoadingCom = () => {
  return (
    <>
    <div className='loading-gif-container'>
      {/* <img src={process.env.PUBLIC_URL + '/images/loading.gif'} className='loading-gif'/> */}
      <Spin/>
    </div>
    </>
  )
}

export default LoadingCom
